
document.addEventListener("DOMContentLoaded", function () {
    const button = document.querySelector('.alto-hero [data-modal-id]');
    const mobileButton = document.querySelector('.alto-hero [data-modal-id-mobile]');
    if (!button && !mobileButton) return;

    function openModal(modalId) {
        const modal = document.getElementById(modalId);
        console.log('modal:', modal);
        if (modal) {
            modal.style.display = "block";
        }
        if (modalOverlay) {
            modalOverlay.style.display = "block";
        }
    }

    if (button) {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            const modalId = button.getAttribute("data-modal-id");
            openModal(modalId);
        });
    }

    if (mobileButton) {
        mobileButton.addEventListener("click", function (event) {
            event.preventDefault();
            const modalId = mobileButton.getAttribute("data-modal-id-mobile");
            openModal(modalId);
        });
    }
});